import moment from 'moment';
import * as t from './actionTypes';

const setLoaded = bool => ({
  type: t.UPDATE_LOADED,
  bool,
});

const asyncHelper = async (type, url, dispatch, client) => {
  dispatch({ type });

  try {
    const result = await client.get(url);

    dispatch({
      type: t.LOAD_SUCCESS,
      result,
    });
    dispatch(setLoaded(false));
  } catch (e) {
    dispatch({
      type: t.LOAD_FAIL,
      error: e,
    });
  }
};

export const loadByDepartureAirportCarrierAndDate =
  ({
    departureAirportCode, carrier, year, month, day, hour,
  }) => {
    let y = year;
    let m = month;
    let d = day;

    if (!year || !month || !day) {
      const now = moment();

      y = now.year();
      m = now.month() + 1;
      d = now.date();
    }

    let url = hour ? `/flights/dep/${departureAirportCode}/${y}/${m}/${d}/${hour}?numHours=6` : `/flights/dep/${departureAirportCode}/${year}/${month}/${day}?numHours=6`;

    url = carrier ? `${url}&carrier=${carrier}` : url;

    return (dispatch, getStore, client) =>
      asyncHelper(t.LOAD_BY_DEPARTURE_AIRPORT_CARRIER_AND_DATE, url, dispatch, client);
  };

export const loadByArrivingAirportCarrierAndDate =
  ({
    arrivalAirportCode, carrier, year, month, day, hour,
  }) => {
    let y = year;
    let m = month;
    let d = day;

    if (!year || !month || !day) {
      const now = moment();
      y = now.year();
      m = now.month() + 1;
      d = now.date();
    }

    let url = hour ? `/flights/arr/${arrivalAirportCode}/${y}/${m}/${d}/${hour}?numHours=6` : `/flights/arr/${arrivalAirportCode}/${year}/${month}/${day}?numHours=6`;

    url = carrier ? `${url}&carrier=${carrier}` : url;

    return (dispatch, getStore, client) =>
      asyncHelper(t.LOAD_BY_ARRIVAL_AIRPORT_CARRIER_AND_DATE, url, dispatch, client);
  };

export const loadByRouteCarrierAndDate =
  ({
    departureAirportCode, arrivalAirportCode, carrier, year, month, day, hour,
  }) => {
    let y = year;
    let m = month;
    let d = day;

    if (!year || !month || !day) {
      const now = moment();
      y = now.year();
      m = now.month() + 1;
      d = now.date();
    }

    let url = hour ? `/flights/route/${departureAirportCode}/${arrivalAirportCode}/${y}/${m}/${d}?numHours=6&hourOfDay=${hour}` :
      `/flights/route/${departureAirportCode}/${arrivalAirportCode}/${year}/${month}/${day}?numHours=6&hourOfDay=6`;

    url = carrier ? `${url}&carrier=${carrier}` : url;

    return (dispatch, getStore, client) =>
      asyncHelper(t.LOAD_BY_ROUTE_CARRIER_AND_DATE, url, dispatch, client);
  };

export const updatePageIndex = (pageIndex, searchUrl) => ({
  type: t.UPDATE_PAGE_INDEX,
  data: {
    pageIndex,
    searchUrl,
  },
});



// WEBPACK FOOTER //
// ./modules/MultiFlight/redux/actions.js